var _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuvBlue = function SvgSuvBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_819",
    "data-name": "Group 819",
    width: 76.06,
    height: 32.714,
    viewBox: "0 0 76.06 32.714",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    transform: "translate(54.813 17.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M532.672,228.657c.079-.141.148-.289.218-.436s.134-.288.194-.438a7.529,7.529,0,0,0,.1-5.374c-.051-.148-.1-.3-.161-.438s-.139-.293-.211-.436a7.631,7.631,0,0,0-13.653,0c-.073.144-.148.288-.211.436s-.109.29-.161.438a7.521,7.521,0,0,0,.1,5.374c.059.15.125.294.193.438s.139.3.218.436a7.639,7.639,0,0,0,13.378,0Zm-2.736-.874a4.661,4.661,0,0,1-.36.438,4.89,4.89,0,0,1-.459.436,4.768,4.768,0,0,1-6.267,0,4.9,4.9,0,0,1-.459-.436,4.652,4.652,0,0,1-.36-.438,4.78,4.78,0,0,1-.176-5.374,4.5,4.5,0,0,1,.313-.438,4.83,4.83,0,0,1,7.272-.436,4.646,4.646,0,0,1,.36.436,4.5,4.5,0,0,1,.313.438,4.78,4.78,0,0,1-.176,5.374Z",
    transform: "translate(-518.336 -217.314)",
    fill: "#06016c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M529.4,213.364l-1.906-1.532a36.04,36.04,0,0,0-15.963-7.325,66.791,66.791,0,0,0-22.287-.356,14.419,14.419,0,0,0-8.392,4.457l-4.436,4.806a7.159,7.159,0,0,0-1.83,4.023h2.432a.436.436,0,0,1,0,.873h-2.513v2.869h2.513a.437.437,0,0,1,0,.874h-2.513v.481a8.717,8.717,0,0,0,.366,2.491h7.733a8.51,8.51,0,0,1,15.589,0h30.978a8.51,8.51,0,0,1,15.589,0h5.805v-1.312a7.605,7.605,0,0,0-.935-3.611h-4.165a.436.436,0,0,1,0-.873h3.609a7.631,7.631,0,0,0-5.228-3.123l-11.283-1.4A6.3,6.3,0,0,1,529.4,213.364Zm-45.122-5.523-4.055,4.677a.438.438,0,0,1-.33.151l-.286-.106a.436.436,0,0,1-.044-.615l4.055-4.679a.437.437,0,1,1,.66.572Zm43.029,5.663-.644-.39.223-.358h0A.89.89,0,0,1,527.307,213.5Zm-.9.04-17.431-.361-.014-.131-.662-6.812c.924.089,1.847.186,2.768.3l.2.025a23.316,23.316,0,0,1,9.386,3.332l5.772,3.6.231-.37Zm-34.736-1.267a5.671,5.671,0,0,1-2.139-1.785L488,208.331a1.332,1.332,0,0,1,.983-2.1l2.175-.166c1.077-.083,2.157-.139,3.237-.185l-2.7,6.371Zm4.038-5.975.2-.474c.935-.029,1.871-.054,2.806-.054,2.731,0,5.463.126,8.183.35l.02.2.664,6.836-13.543-.281a5.519,5.519,0,0,1-1.064-.134Zm1.735,10.189h-2.261a.436.436,0,0,1,0-.873h2.261a.436.436,0,0,1,0,.873Zm15.7,0h-2.261a.436.436,0,0,1,0-.873h2.261a.436.436,0,0,1,0,.873Z",
    transform: "translate(-474.507 -203.384)",
    fill: "#06016c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(23.92 22.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M524.145,226.762a8.436,8.436,0,0,1-.1-5.374H493.734a8.425,8.425,0,0,1-.1,5.374Z",
    transform: "translate(-493.634 -221.388)",
    fill: "#06016c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816",
    transform: "translate(8.247 17.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M495.437,228.657c.079-.141.148-.289.218-.436s.134-.288.193-.438a7.538,7.538,0,0,0,.1-5.374c-.052-.148-.1-.3-.163-.438s-.138-.293-.21-.436a7.631,7.631,0,0,0-13.653,0c-.073.144-.148.288-.211.436s-.11.29-.161.438a7.53,7.53,0,0,0,.1,5.374c.06.15.125.294.194.438s.139.3.218.436a7.639,7.639,0,0,0,13.378,0Zm-10.281-.436a4.765,4.765,0,0,1-1.278-3.26,4.823,4.823,0,0,1,.74-2.551,4.97,4.97,0,0,1,.313-.438,5.058,5.058,0,0,1,.36-.436,4.724,4.724,0,0,1,7.274.436,4.705,4.705,0,0,1,.313.438,4.786,4.786,0,0,1-.536,5.812,4.89,4.89,0,0,1-.459.436,4.769,4.769,0,0,1-6.268,0A5.031,5.031,0,0,1,485.155,228.221Z",
    transform: "translate(-481.101 -217.314)",
    fill: "#06016c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    transform: "translate(70.488 22.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M531.643,226.762a4.8,4.8,0,0,0,4.8-4.8v-.578H530.97a8.448,8.448,0,0,1-.1,5.374Z",
    transform: "translate(-530.87 -221.388)",
    fill: "#06016c"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(0.675 22.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M475.047,221.388a8.757,8.757,0,0,0,7.174,5.329,8.428,8.428,0,0,1-.084-5.329Z",
    transform: "translate(-475.047 -221.388)",
    fill: "#06016c"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuvBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suvBlue.7e1994c9.svg";
export { ForwardRef as ReactComponent };